import { makeVar } from "@apollo/client";

export const defaultTextResource = {
  textResourceCode: null,
  label: null,
  labelENU: null,
  labelFRA: null
};

export const textResourceModalVar = makeVar({
  open: false,
  saving: false,
  method: defaultTextResource
});
